import { render, staticRenderFns } from "./WeightCharge.vue?vue&type=template&id=0864a049&"
import script from "./WeightCharge.vue?vue&type=script&lang=js&"
export * from "./WeightCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports